const trimPayload = (_?: unknown) => {};
export { trimPayload };
